import { camelCase, transform } from 'lodash';

type SnakeToCamel<K extends PropertyKey> = K extends `${infer L}_${infer C}${infer R}`
    ? SnakeToCamel<`${L}${Capitalize<C>}${R}`>
    : K;

export const objectKeysToCamelCase = <T extends Record<string, any>>(
    object: T
): { [key in keyof T as SnakeToCamel<key>]: T[key] } => {
    return transform(object, (result, val, key) => {
        (result as any)[camelCase(key)] = val;
    });
};
